<template>
  <div class="mod-config">
    <!-- <el-form>
      <el-form-item>
        <el-button  type="primary" @click="addOrUpdateHandle()">新增</el-button>
      </el-form-item>
    </el-form> -->
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      style="width: 100%;">
      <el-table-column
        prop="noticeTypeName"
        header-align="center"
        align="center"
        label="通知公告类型">
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="通知公告内容">
         <template slot-scope="scope">
           <div v-html="scope.row.noticeContent"></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        label="创建时间">
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
     <el-dialog
        title="修改"
        :close-on-click-modal="false"
        
        :visible.sync="addOrUpdateVisible">
        <el-form :model="datas"  label-width="80px">
        <el-form-item label="公告类型" >
          <el-input v-model="datas.noticeTypeName" :disabled='true' placeholder="通知公告类型"></el-input>
        </el-form-item>
        <el-form-item label="内容">
            <quill-editor v-model="datas.noticeContent" style="height: 200px;" >
      </quill-editor>
      
        </el-form-item>
         <el-form-item >
        
        </el-form-item>
      <el-form-item >
        
        </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addOrUpdateVisible = false">取消</el-button>
          <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
        </span>
      </el-dialog>
    
  </div>
</template>

<script>

  import { noticeList, noticeUpdate } from './api'
  import {
    quillEditor
  } from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  export default {
     components: {
      quillEditor
    },
    data () {
      return {
        dataForm: {
          key: ''
        },
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: [],
        addOrUpdateVisible: false,
        datas:{}
      }
    },
    
    mounted () {
      this.getDataList()
    },
    methods: {
      dataFormSubmit() {
        noticeUpdate({noticeId:this.datas.noticeId,noticeContent:this.datas.noticeContent}).then(res =>{
          if(res.code==0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
              })
              this.addOrUpdateVisible = false
              this.getDataList()
          }
        })
        
      },
      // 获取数据列表
      getDataList () {
        this.dataListLoading = true
       noticeList({
            'page': this.pageIndex,
            'limit': this.pageSize,
            'key': this.dataForm.key
        }).then(data => {
          if (data && data.code === 0) {
            this.dataList = data.page.list
            this.totalPage = data.page.totalCount
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 新增 / 修改
      addOrUpdateHandle (item) {
        this.addOrUpdateVisible = true
        this.datas = item
      },
      // 删除
      deleteHandle (id) {
        var ids = id ? [id] : this.dataListSelections.map(item => {
          return item.noticeId
        })
        this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            url: this.$http.adornUrl('/sys/notice/delete'),
            method: 'post',
            data: this.$http.adornData(ids, false)
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        })
      }
    }
  }
</script>
